import { ICoverageRuleStoreSegment } from './coverageRule.interface';

export const coverageRuleStoreSelector = (state: ICoverageRuleStoreSegment) => state.coverageRule;
